export enum Roles {
  SUPERADMIN = 1,
  ADMIN = 2,
  EXTENSION_USER = 3,
}

export const roleMap = {
  1: 'Org. owner',
  2: 'Admin',
  3: 'Extension user',
}
